module.exports = __webpack_public_path__ + "static/jason-atkins-headshot-def0a586b7cd29e3281b049fc8deea3d.png";